export default __webpack_public_path__ + "static/media/banks-supported.b0ba78ab.png";